import * as yup from 'yup';

const dateStringRegex = /^[01]\d\/[0-3]\d\/\d{4}$/;

export const blastingTypeSchema = yup.object().shape({
	permitType: yup.string().matches(/(annual)|(single)/, 'Invalid Permit'),
	date: yup.string().when('permitType', {
		is: 'single',
		then: schema =>
			schema
				.matches(dateStringRegex, 'Invalid Date')
				.required('A date is required'),
		otherwise: schema => schema.optional(),
	}),
	startDate: yup.string().when('permitType', {
		is: 'annual',
		then: schema =>
			schema
				.matches(dateStringRegex, 'Invalid Date')
				.required('Start Date is required.'),
		otherwise: schema => schema.optional(),
	}),
	endDate: yup.string().when('permitType', {
		is: 'annual',
		then: schema =>
			schema
				.matches(dateStringRegex, 'Invalid Date')
				.required('End Date is required.'),
		otherwise: schema => schema.optional(),
	}),
});
